import {Component, ViewEncapsulation, OnInit, AfterViewInit} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SelfAttendanceService } from '../../shared/services/self-attendance.service';
import { DtmService } from '../../services/dtm.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogLoadingComponent } from '../../shared/components/dialog-loading/dialog-loading.component';
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';

import {
  authReasonCode,
  getCancelContractDataError,
  handleIntegrationError,
} from '../../shared/constants/errors';
import {BankData} from '../../shared/model/bank-data';
import {CancellationReason} from '../../shared/model/cancellation-reason';
import {Observable} from 'rxjs';
import {masks} from '../../shared/constants/masks';
import {ValidateCPFCNPJ, ValidateName, ValidateText} from '../../shared/validators/custom.validator';
import {CustomerBankData} from '../../shared/model/customer-bank-data';
import {Dtm, Rules, getDtm} from '../../shared/enum/dtm';
import {SYDLEClientID} from '../../shared/constants/one-constants';
import {SessionStorageService} from "../../shared/services/session-storage.service";
import { Contract } from 'src/app/shared/model/contract';
import { environment } from 'src/environments/environment';
import { UtilsService } from 'src/app/shared/services/utils.service';

export enum Mapping {
  'saude-do-seu-negocio' = 'SaudeFinanceira',
  'consulta-e-recuperacao-de-dividas' = 'CS-RDD',
  'monitore-clientes' = 'Serasa Monitora',
  'lista-online' = 'Prospeccao',
  'plano-mensal' = "Assinatura",
  'plano-mensal-recarga-pontual' = "AssinaturaRecargaPontual",
  'descomplica' = "Descomplica"
}

@Component({
    selector: 'pme-self-attendance-cancellation',
    templateUrl: './cancellation.component.html',
    styleUrls: ['./cancellation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SelfAttendanceCancellationComponent implements OnInit, AfterViewInit {
  reasonsForCancellation: Array<CancellationReason>;
  filteredBanks: Observable<Array<BankData>>;
  banks: Array<BankData>;

  cancellationForm: UntypedFormGroup;
  cancelFormErrors: Array<string> = [];

  hashString: string;
  redirectUrl: string;
  originOfRequest: string;
  startDate: string;
  endDate: string;
  planName: string;
  value: string;
  paymentMethod: string;
  businessId: string;
  userId: string;
  selectedOption: string;
  heroData: any = {};
  showHero: boolean;
  days: number;
  accountBankData: any = {};

  customerBankData: CustomerBankData;
  message: any;
  classificationIdentifier: string;

  submitting: boolean = false;
  showForm: boolean = false;

  hasScheduleCancelDate: Boolean = false;
  cancelBuyIntention: Boolean = false;

  errorResponse: any;

  pageLoadEventSent: boolean = false;
  plan: string;
  showBankForm: boolean = false;
  isActiveTrial: boolean;

  bankPixContract: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    public dialog: MatDialog,
    public dtmService: DtmService,
    private selfAttendanceService: SelfAttendanceService,
    public sessionStorageService: SessionStorageService,
    private utils: UtilsService
  ) {
    this.classificationIdentifier = this.sessionStorageService.getClassification(this.route);

    this.cancellationForm = this.formBuilder.group({
      reasonForCancellation: ["", [Validators.required]],
      message: ["", [ValidateText]],
      bank: [],
      agency: [],
      account: [],
      name: [],
      cpfCnpj: [],
      accountType: []
    });

    this.route.queryParams.subscribe((params) => {
      this.hashString = params.hash;
      this.businessId = params.businessId;
      this.userId = params.userId;
      sessionStorage.setItem('selfAttendance', 'true');

      if(params.redirectUrl){
        this.redirectUrl = params.redirectUrl;
        sessionStorage.setItem('redirectUrl', this.redirectUrl);
        this.selfAttendanceService.redirectURL = this.redirectUrl;
      }
    });
  }

  cpfCnpjMask = '000.000.000-00||00.000.000/0000-00';

  ngOnInit() {
    this.openDialogSpinner();
    this.selfAttendanceService.authenticate(this.classificationIdentifier, this.hashString, this.businessId, this.userId, true).subscribe(
      (contractData) => {
        this.businessId = contractData.businessId;
        this.userId = contractData.userId;

        if (contractData.userName && contractData.userEmail) {
          sessionStorage.setItem('name', contractData.userName);
          sessionStorage.setItem('email', contractData.userEmail);
        }

        sessionStorage.setItem('businessId', contractData.businessId);
        sessionStorage.setItem('userId', contractData.userId);

        this.dtmService.userLoaded({
          userId: this.userId,
          businessId: this.businessId,
          clientId: SYDLEClientID
        });

        // TESTES DE ERRO HERO
        // this.businessId = null;
        // this.userId = null;
        // this.businessId = 'lala';
        // this.userId = 'pooo';

        this.selfAttendanceService.getCancelContractData(this.userId, this.businessId, this.classificationIdentifier).subscribe(
          (cancelData) => {
            sessionStorage.setItem('cancelData', JSON.stringify(cancelData));

            this.showForm = true;
            this.startDate = cancelData.startDate;
            this.plan = cancelData.planIdentifier;
            this.planName = cancelData.planName;
            this.value = cancelData.value;
            this.days = cancelData.days;
            this.paymentMethod = cancelData.paymentMethod;
            this.endDate = cancelData.endDate;
            this.isActiveTrial = cancelData.isActiveTrial;

            if ((this.paymentMethod === 'BANK_BILLET' || this.paymentMethod === 'PIX')) {
              this.bankPixContract = true;
            }

            if (cancelData.reasons) {
              this.reasonsForCancellation = cancelData.reasons.map(reason => new CancellationReason(reason));
            }

            if(cancelData.bankData) {
              this.banks = cancelData.bankData.map(bank => new BankData(bank));

              // ordenando bancos por código do banco
              this.banks = this.banks.sort((a, b) => {
                return Number(a.code) - Number(b.code);
              })
            }

            this.pageLoadEventSent = true;
            this.closeDialogSpinner();
          },
          (error) => {
            this.hasScheduleCancelDate = error.error && error.error.generalMessages &&  error.error.generalMessages.length > 0 && error.error.generalMessages[0].text && error.error.generalMessages[0].text.indexOf("O Contrato que estava com cancelamento agendado foi reativado!") !== -1;
            this.cancelBuyIntention = error.error && error.error.generalMessages &&  error.error.generalMessages.length > 0 && error.error.generalMessages[0].text && error.error.generalMessages[0].text.indexOf("Intenção de compra cancelada!") !== -1;
            if (this.hasScheduleCancelDate || this.cancelBuyIntention) {
              let errorMsg = JSON.parse(error.error.generalMessages[0].text);
              this.errorResponse = errorMsg.errorResponse;

              let msg = errorMsg.msg;
              error.error.generalMessages[0].text = msg;
            }
            this.showCustomError('getCancelContractDataError', error);
          }
        );
      },
      (error) => {
        this.hasScheduleCancelDate = error.error && error.error.generalMessages &&  error.error.generalMessages.length > 0 && error.error.generalMessages[0].text && error.error.generalMessages[0].text.indexOf("O Contrato que estava com cancelamento agendado foi reativado!") !== -1;
        this.cancelBuyIntention = error.error && error.error.generalMessages &&  error.error.generalMessages.length > 0 && error.error.generalMessages[0].text && error.error.generalMessages[0].text.indexOf("Intenção de compra cancelada!") !== -1;
        if (this.hasScheduleCancelDate || this.cancelBuyIntention) {
          let errorMsg = JSON.parse(error.error.generalMessages[0].text);
          this.errorResponse = errorMsg.errorResponse;

          if (this.hasScheduleCancelDate) {

            // Adobe Analytics
            this.dtmService.pageLoaded(Dtm.DesistirCancelamento, true, getDtm(Dtm.DesistirCancelamento, this.classificationIdentifier));
            this.dtmService.ruleChange(Rules.CancelarPlanoDesistirCancelamento);
            this.dtmService.customCancellation(['CancelarPlanoDesistirCancelamento'], this.selectedOption);
            this.dtmService.productsLoaded([{
              identifier: this.errorResponse.productIdentifier,
              classificationName: this.errorResponse.classificationName
            }]);
            this.dtmService.userLoaded({
              userId: this.userId,
              businessId: this.businessId,
              clientId: SYDLEClientID
            });
            this.dtmService.sendPageLoadEvent("CancelarPlanoDesistirCancelamento");

          } else {
            // Adobe Analytics
            this.dtmService.pageLoaded(Dtm.DesistirCompra, true, getDtm(Dtm.DesistirCompra, this.classificationIdentifier));
            this.dtmService.ruleChange(Rules.CancelarPlanoDesistirCompra);
            this.dtmService.customCancellation(['CancelarPlanoDesistirCompra'], this.selectedOption);
            this.dtmService.productsLoaded([{
              identifier: this.errorResponse.productIdentifier,
              classificationName: this.errorResponse.classificationName
            }]);
            this.dtmService.userLoaded({
              userId: this.userId,
              businessId: this.businessId,
              clientId: SYDLEClientID
            });
            this.dtmService.sendPageLoadEvent("CancelarPlanoDesistirCompra");

          }
          let msg = errorMsg.msg;
          error.error.generalMessages[0].text = msg;
        }

        this.showCustomError('authenticationError', error);
      }
    );

    // Adobe Analytics - Padronizacao Fevereiro/2025
    this.dtmService.userLoaded({
      userId: this.userId,
      businessId: this.businessId,
      clientId: SYDLEClientID
    });
    this.dtmService.pageLoaded(Dtm.Cancelamento, true, getDtm(Dtm.Cancelamento, this.classificationIdentifier));
    this.dtmService.sendPageLoadEvent();
  }

  ngAfterViewInit() {}

  private _filter(value: string): Array<BankData> {
    const filterValue = value.toLowerCase();
    return this.banks.filter(option => option.name.toLowerCase().includes(filterValue) || option.code.toLowerCase().includes(filterValue));
  }

  onSubmit() {
    if (this.cancellationForm.valid) {
      const cancelReason = this.getReasonByIdentifier(this.selectedOption);
      sessionStorage.setItem('cancelReason', cancelReason);
      sessionStorage.setItem('cancelReasonOption', this.selectedOption);
      sessionStorage.setItem('cancelMessage', this.message);

      this.dtmService.customClickEvent("AutoAtendimento:" + this.mapIdentifier(this.classificationIdentifier) + ":Cancelamento:CancelarCompra");
      this.cancelFormErrors = [];

      this.submitting = true;
      this.disableFields('all');

      this.router.navigate(['retencao'], { relativeTo: this.route });
    }
  }

  openDialogSpinner(): void {
    this.closeDialogSpinner();
    this.dialog.open(LoadingComponent, {
      disableClose: true,
      width: "400px",
      panelClass: "pme-dialog-loading-panel",
      backdropClass: 'pme-dialog-loading-backdrop'
    });
  }

  closeDialogSpinner(): void {
    this.dialog.closeAll();
  }

  showCustomError(customErrorKey: string, integrationError?: any) {
    let integrationErrorMessage: any;
    switch (customErrorKey) {
      case 'authenticationError':
        if(this.hasScheduleCancelDate) {
          integrationErrorMessage = this.showCustomHeroError(integrationError, 'scheduleCancelDataError');
        } else if(this.cancelBuyIntention) {
          integrationErrorMessage = this.showCustomHeroError(integrationError, 'cancelBuyIntention');
        } else {
          integrationErrorMessage = this.showCustomHeroError(integrationError, 'authenticationError');
        }

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;
      case 'getCancelContractDataError':
        if(this.hasScheduleCancelDate){
          integrationErrorMessage = this.showCustomHeroError(integrationError, 'scheduleCancelDataError');
        } else if(this.cancelBuyIntention){
          integrationErrorMessage = this.showCustomHeroError(integrationError, 'cancelBuyIntention');
        } else {
          integrationErrorMessage = this.showCustomHeroError(integrationError, 'getCancelContractDataError');
        }

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;
      case 'cancelContractError':
        integrationErrorMessage = handleIntegrationError(integrationError);

        console.error(integrationErrorMessage);

        this.cancelFormErrors.push(integrationErrorMessage.userMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;
      default:
        break;
    }

    this.closeDialogSpinner();
    if (this.showForm) {
      this.submitting = false;
      this.enableFields('all');
    }
  }

  showCustomHeroError(error, type) {
    let resultError: any = {};

    try {
      if (typeof error === "string") {
        error = JSON.parse(error);
      }

      if (error.status && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url;
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === "ERROR";
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === "WARNING";
        });

        // Nova errorString
        resultError.errorString = (resultError.context || "SYDLE") + ":CODE:" + error.status + ":HTTP:" + (resultError.errorCode || resultError.status) + ":POST/" + resultError.endpoint + ":" + JSON.stringify(resultError.errors.map(({ text }) => text));

        //resultError.errorString = `${resultError.status}:${resultError.name}:${resultError.endpoint}:${JSON.stringify(resultError.errors)}:${JSON.stringify(resultError.warnings)}`;

        resultError.userMessage = error.error._messages[0].text;
        resultError.code = error.error._messages[0].code;

        switch (type) {
          case 'authenticationError':
            if (authReasonCode[resultError.code]) {
              this.heroData.type = authReasonCode[resultError.code].type || 'error';
              this.heroData.title = authReasonCode[resultError.code].title;
              this.heroData.contents = authReasonCode[resultError.code].contents;
            } else {
              this.heroData.type = 'error';
              this.heroData.title = 'Serviço indisponível!';
              this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
            }
            break;
          case 'getCancelContractDataError':
            if (getCancelContractDataError[resultError.code]) {
              this.heroData.type = 'error';
              this.heroData.title = getCancelContractDataError[resultError.code].title;
              this.heroData.contents = getCancelContractDataError[resultError.code].contents;
            } else {
              this.heroData.type = 'error';
              this.heroData.title = 'Serviço indisponível!';
              this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
            }
            break;
          case 'scheduleCancelDataError':
            if (getCancelContractDataError[resultError.code]) {
              this.heroData.type = 'success';
              this.heroData.title = getCancelContractDataError[resultError.code].title;
              this.heroData.contents = ["A assinatura que estava com o cancelamento agendado foi reativada. Sua próxima renovação será em " + this.formatDate(this.errorResponse.nextRecurrenceDate) + "."];
            } else {
              this.heroData.type = 'error';
              this.heroData.title = 'Serviço indisponível!';
              this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
            }
            break;
          case 'cancelBuyIntention':
              if (getCancelContractDataError[resultError.code]) {
                this.heroData.type = 'success';
                this.heroData.title = getCancelContractDataError[resultError.code].title;
                this.heroData.contents = ['Desconsidere o ' + this.errorResponse.paymentMethod + ' emitido para o ' + this.errorResponse.productName + " com vencimento em " + this.formatDate(this.errorResponse.expirationDateInvoice) + "."];
              } else {
                this.heroData.type = 'error';
                this.heroData.title = 'Serviço indisponível!';
                this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
              }
              break;
          default:
            this.heroData.type = 'error';
            this.heroData.title = 'Serviço indisponível!';
            this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
            break;
        }
      }
    } catch (e) {
      console.error(e);
      resultError.errorString = JSON.stringify(error);
      this.heroData.type = 'error';
      this.heroData.title = 'Serviço indisponível!';
      this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
    }

    this.heroData.showButton = true;
    this.heroData.buttonName = 'Ir para área logada';
    this.heroData.redirectURL =  environment.serasaHomePage || this.redirectUrl;
    this.showHero = true;
    return resultError;
  }

  /**
   * Lidando com erros do form de cartão de crédito
   */
  getBankFormErrors(): { [key: string]: any } {
    const map: { [key: string]: string } = {};
    // Validando requireds
    Object.keys(this.cancellationForm.controls).forEach((key) => {
      const keyName = key.toString();
      map[keyName] = this.cancellationForm.controls[keyName].hasError("required")
        ? "Campo obrigatório"
        : null;
      //map[keyName] =
    });
    // // Validacoes específicas
    map.reasonForCancellation =  map.reasonForCancellation ||  this.cancellationForm.controls.reasonForCancellation.getError("reasonForCancellationError");
    map.message =  map.message ||  this.cancellationForm.controls.message.getError("messageError");
    map.bank =  map.bank ||  this.cancellationForm.controls.bank.getError("bankError");
    map.agency =  map.agency ||  this.cancellationForm.controls.agency.getError("agencyError");
    map.account =  map.account ||  this.cancellationForm.controls.account.getError("accountError");
    map.name =  map.name ||  this.cancellationForm.controls.name.getError("nameError");
    map.cpfCnpj =  map.cpfCnpj ||  this.cancellationForm.controls.cpfCnpj.getError("cpfCnpjError");
    map.accountType =  map.accountType ||  this.cancellationForm.controls.accountType.getError("accountTypeError");

    map.reasonForCancellation = "Selecione um motivo";
    map.message = "Descreva o motivo com pelo menos 20 caracteres para seguir com o cancelamento.";

    return map;
  }

  formatDate(date){
    let scheduleDate = new Date(new Date(date).getTime() + 3*60*60*1000);
    let formatedDate = "";
    scheduleDate.getDate() + "/" + (scheduleDate.getUTCMonth()+1) + "/" + scheduleDate.getUTCFullYear()

    if(scheduleDate.getDate() < 10){
      formatedDate += "0" + scheduleDate.getDate();
    } else {
      formatedDate += scheduleDate.getDate();
    }

    formatedDate += "/";

    if((scheduleDate.getUTCMonth()+1) < 10){
      formatedDate += "0" +  (scheduleDate.getUTCMonth()+1);
    } else {
      formatedDate += (scheduleDate.getUTCMonth()+1);
    }

    formatedDate += "/";

    formatedDate += scheduleDate.getUTCFullYear();

    return formatedDate;

  }

  /**
   * Desativa campos do formulário
   * @param fieldName - campo que deve ser desativado, em caso de 'all', desativa todos
   */
  disableFields(fieldName: string){
    if (fieldName === "all") {
      Object.keys(this.cancellationForm.controls).forEach(
        (key) => {
          const keyName = key.toString();
          this.cancellationForm.controls[
            keyName
            ].disable();
        }
      );
    } else {
      if (this.cancellationForm.controls[fieldName]) {
        this.cancellationForm.controls[
          fieldName
          ].disable();
      }
    }
  }

  /**
   * Ativa campos do formulário
   * @param fieldName - campo que deve ser ativado, em caso de 'all', ativa todos
   */
  enableFields(fieldName: string){
    if (fieldName === "all") {
      console.info("enabling all fields");
      Object.keys(this.cancellationForm.controls).forEach(
        (key) => {
          const keyName = key.toString();
          this.cancellationForm.controls[
            keyName
            ].enable();
        }
      );
    } else {
      if (this.cancellationForm.controls[fieldName]) {
        this.cancellationForm.controls[
          fieldName
          ].enable();
      }
    }
  }

  getReasonByIdentifier(identifier: string): string {
    const reasonObj = this.reasonsForCancellation.find(
      (reason) => reason.identifier === identifier
    );
    return reasonObj ? reasonObj.reason : '';
  }

  mapIdentifier(identifier: string): string {
    if (identifier in Mapping) {
      return Mapping[identifier as keyof typeof Mapping];
    }

    return identifier;
  }
}
